import React from "react";
import Image from "../../Tags/Image";

export default function ProgramsAndPartnerships({ data = {} }) {
  let program = {
    startup_program_url: data?.startup_program_url,
    partner_program_url: data?.partner_program_url,
    has_partners_program: data?.has_partners_program,
    affiliate_program_url: data?.affiliate_program_url,
    startup_program_available: data?.startup_program_available,
    has_reseller_program: data?.has_reseller_program,
    reseller_program_url: data?.reseller_program_url,
  };

  const checkIsEmpty = (obj) => {
    const isEmpty = Object.values(obj).every((x) => x === null || x === "" || x === false);
    return isEmpty;
  };

  const makeLink = (link) => {
    if (link && link.charAt(0) === "/") {
      return `https://${data?.domain}${link}`;
    } else {
      return link;
    }
  };
  const CardLink = ({ heading, link }) => (
    <div className="border rounded-[14px] overflow-hidden border-input  bg-gray-100 relative p-4 w-[48.5%] inline-flex items-center mr-[1.5%] mb-[1%]">
      <Image src="/images/ext/companyinfo/code.svg" className="mr-3 no-invert" />
      <span className="text-[16px] text-gray-900 block">{heading}</span>
      {makeLink(link) && (
        <a href={makeLink(link)} target="_blank" className="ml-2">
          {" "}
          <Image className="no-invert" src="/images/ext/crm/hyperlink.svg" />
        </a>
      )}
    </div>
  );
  console.log("program", program);
  return (
    <>
      {!checkIsEmpty(program) ? (
        <div className="border rounded-[14px] overflow-hidden border-border  bg-background relative mt-4 p-4 pb-2">
          <div className="mb-4">
            <span className="text-[16px] text-text-700 mr-3 font-bold">Programs and Partnerships</span>
            <span className="block text-sm">
              Discover engagement and business collaboration opportunities
            </span>
          </div>
          <div className="mt-3 -mr-3">
            {program && program?.affiliate_program_url && (
              <CardLink heading="Affiliate Program" link={program?.affiliate_program_url} />
            )}
            {program && program?.reseller_program_url && (
              <CardLink heading="Reseller Program" link={program?.reseller_program_url} />
            )}
            {program && program?.startup_program_url && (
              <CardLink heading="Startup Program" link={program?.startup_program_url} />
            )}
            {program && program?.partner_program_url && (
              <CardLink heading="Partner Program" link={program?.partner_program_url} />
            )}
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </>
  );
}
